import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    userId: null,
    username: null,
    email: null,
    phoneNumber: null,
  });

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser({
      userId: null,
      username: null,
      email: null,
      phoneNumber: null,
    });
  };

  return (
    <UserContext.Provider value={{ user, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
